<template>
  <div class="user-subscriptions-page" v-if="currentUser">
    <BuyPlanModal :plans="subscriptions" :userEmail="user.email" />

    <div class="page-header">
      <h1>Subskrypcje</h1>
    </div>

    <div class="section-card">
      <div class="tabs">
        <button class="tab-btn" :class="{ active: view == '0' }" @click="view = '0'" v-if="!user.subscription">Pakiety</button>
        <button class="tab-btn" :class="{ active: view == '1' }" @click="view = '1'">Aktywne subskrypcje</button>
        <button class="tab-btn" :class="{ active: view == '2' }" @click="view = '2'" v-if="user.payments_history && user.payments_history.length > 0">Historia płatności</button>
        <button class="tab-btn" :class="{ active: view == '3' }" @click="view = '3'" v-if="user.subscription">SMS-y</button>
      </div>
    </div>

    <div v-if="view == '0'" class="section-card">
      <div class="section-card-header">
        <h2>Pakiety abonamentowe</h2>
      </div>
      <div class="plans-grid">
        <SubPlanCard
            v-for="sub in subscriptions"
            :key="sub.id"
            @refreshSubscriptions="getSubscriptions"
            :id="sub.id"
            :name="sub.name"
            :subscription-m="sub.subscriptionM"
            :additional-s-m-s="sub.additionalSMS"
            :additional-user-m="sub.additionalUserM"
            :free-users="sub.freeUsers"
            :free-s-m-s="sub.freeSMS"
            :period="sub.period"
            :admin="true"
        />
      </div>
    </div>

    <div v-if="view == '1'" class="section-card position-relative">
      <HintComponent page-key="business_panel_active_subscriptions" :absolute="true" />
      <div class="section-card-header">
        <h2>Aktywna subskrypcja</h2>
      </div>

      <div v-if="!user.subscription" class="empty-state">
        <p>Brak aktywnych subskrypcji. Wybierz pakiet, aby korzystać z pełnych możliwości serwisu.</p>
      </div>

      <div v-else class="active-card">
        <div class="active-head">{{ user.subscription.subscription.name }}</div>
        <div class="active-row"><span>Status</span><b>Aktywny</b></div>
        <div class="active-row"><span>Data wygaśnięcia</span><b>{{ user.subscription.date }}</b></div>
        <div class="active-row"><span>Dodatkowi pracownicy</span><b>{{ user.subscription.users ? user.subscription.users : '0' }}</b></div>

        <button class="btn-primary" @click="isExpanding = true">Rozszerz plan</button>

        <div class="expand-plan" v-if="isExpanding">
          <label for="additionalUsers">Ilość użytkowników do dodania</label>
          <input type="number" id="additionalUsers" v-model="additionalUsers" min="1">
          <span>Pozostały czas: {{ getLeftPLanMonths() }} mies.</span>
          <span>Cena za użytkownika: {{ user.subscription.subscription.additionalUserM }} zł</span>
          <span>Łącznie: {{ additionalUsers * user.subscription.subscription.additionalUserM * getLeftPLanMonths() }} zł</span>
          <div class="expand-actions">
            <button class="btn-outline" @click="isExpanding = false">Anuluj</button>
            <button class="btn-primary" @click="expandPlan()">Zatwierdź</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="view == '2' && user.payments_history" class="section-card">
      <div class="section-card-header">
        <h2>Historia płatności</h2>
      </div>

      <div class="history-grid">
        <div v-for="sub in user.payments_history" :key="sub.id" class="history-item">
          <div class="history-head">{{ subscriptions.find(item => item.id == sub.subscription_id) ? subscriptions.find(item => item.id == sub.subscription_id).name : 'Subskrypcja' }}</div>
          <div class="history-row"><span>Status</span><b>Nieaktywny</b></div>
          <div class="history-row"><span>Od</span><b>{{ sub.date_from }}</b></div>
          <div class="history-row"><span>Do</span><b>{{ sub.date_to }}</b></div>
        </div>
      </div>
    </div>

    <div v-if="view == '3'" class="section-card position-relative">
      <HintComponent page-key="business_panel_subscription_sms" :absolute="true" />
      <div class="section-card-header">
        <h2>Powiadomienia SMS</h2>
      </div>

      <div class="sms-grid">
        <div class="sms-card">
          <h3>Licznik wysłanych SMS-ów</h3>
          <p>{{ user.sent_sms ? user.sent_sms : '0' }} sms</p>
          <p>{{ user.sent_sms ? (user.sent_sms * user.subscription.subscription.additionalSMS).toPrecision(2) : '0' }} zł</p>
        </div>

        <div class="sms-card">
          <h3>Status wysyłki</h3>
          <div class="switch-container">
            <span>wył.</span>
            <label class="switch">
              <input type="checkbox" @change="smsBlockSwitch" :checked="user.sending_sms_active === null || user.sending_sms_active ? true : false">
              <span class="slider round"></span>
            </label>
            <span>wł.</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useMeta } from 'vue-meta';
import SubPlanCard from '@/components/SpecialComponents/SubPlanCard.vue';
import axios from 'axios';
import BuyPlanModal from '@/components/SpecialComponents/BuyPlanModal.vue';
import authHeader from '@/services/auth-header';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';
import HintComponent from "@/components/SpecialComponents/HintComponent.vue";

export default {
  name: 'UserSubscriptions',
  components: {HintComponent, SubPlanCard, BuyPlanModal },
  setup() {
    useMeta({ title: 'Subskrypcje' });

    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    };
  },
  data() {
    return {
      view: '0',
      subscriptions: [],
      user: {},
      additionalUsers: 1,
      isExpanding: false
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    }
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 2) {
      this.$router.push('/login');
    }
    this.getSubscriptions();
    this.getUserData();
  },
  methods: {
    getSubscriptions() {
      axios.post('/SubscriptionSearch', {
        page: 1,
        limit: 100
      }).then(res => {
        this.subscriptions = res.data.items;
      }).catch(() => {});
    },
    getUserData() {
      axios.get(`/User/${this.currentUser.id}`).then(res => {
        this.user = res.data;
        if (this.user.payments_history && this.user.payments_history.length > 0) {
          this.user.payments_history.pop();
        }
        if (this.user.subscription) {
          this.view = '1';
        }
      }).catch(() => {});
    },
    expandPlan() {
      this.isExpanding = false;
      const ob = {
        payment_name: `Rozszerz plan: ${this.user.subscription.subscription.name}`,
        subscription_id: this.user.subscription.subscription.id,
        users: this.additionalUsers,
        buyer_email: this.user.email,
        only_update: true
      };
      axios.post('/GetPaymentUrl', ob, authHeader()).then(res => {
        window.location.replace(res.data.payment_url);
      });
    },
    getLeftPLanMonths() {
      let expirationDate = new Date(this.user.subscription.date);
      let today = new Date();
      let difference = expirationDate.getTime() - today.getTime();
      let differenceInDays = Math.round(difference / (1000 * 3600 * 24));
      let differenceInMonths = Math.ceil(differenceInDays / 30);
      return differenceInMonths;
    },
    smsBlockSwitch() {
      const currentState = this.user.sending_sms_active === null || this.user.sending_sms_active ? true : false;
      axios.post('/SwitchSmsBlock', {
        sending_sms_active: !currentState
      }, authHeader()).then(res => {
        if (String(res.status).charAt(0) === '2') {
          this.appStore.setIsSuccess(currentState ? 'zablokowano wysyłanie sms' : 'odblokowano wysyłanie sms');
          this.user.sending_sms_active = !currentState;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.user-subscriptions-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  margin: 0;
  font-size: 2.8rem;
  color: #1f2937;
  font-weight: 700;
}

.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0,0,0,.08);
  padding: 24px;
  margin-bottom: 20px;
}

.section-card-header h2 {
  margin: 0;
  font-size: 2rem;
  color: #1f2937;
}

.tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tab-btn {
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  background: #fff;
  color: #1f2937;
  font-size: 1.4rem;
  cursor: pointer;
}
.tab-btn.active {
  background: #f97316;
  border-color: #f97316;
  color: #fff;
}

.plans-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
}

.active-card,
.history-item,
.sms-card {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px;
}

.active-head,
.history-head {
  font-size: 1.7rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 10px;
}

.active-row,
.history-row {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
  font-size: 1.4rem;
}

.expand-plan {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 12px;
  border-top: 1px solid #e5e7eb;
}

.expand-plan input {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 1.4rem;
  outline: none;
}
.expand-plan input:focus {
  border-color: #10b981;
}

.expand-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.history-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.history-item {
  width: 100%;
  max-width: 280px;
}

.sms-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(220px, 1fr));
  gap: 12px;
}

.sms-card h3 {
  margin: 0 0 8px;
}
.sms-card p {
  margin: 4px 0;
  font-size: 1.4rem;
}

.empty-state {
  text-align: center;
  color: #9ca3af;
  border: 1px dashed #d1d5db;
  border-radius: 10px;
  padding: 24px;
  font-size: 1.5rem;
}

.btn-primary {
  background: #f97316;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: 600;
}
.btn-primary:hover { background: #ea6c0a; }

.btn-outline {
  background: #fff;
  color: #1f2937;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 14px;
  cursor: pointer;
  font-size: 1.4rem;
}
.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

.switch-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}
.switch input {
  opacity: 0; width: 0; height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background-color: #ccc;
  transition: .4s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: #fff;
  transition: .4s;
}
input:checked + .slider { background-color: #f97316; }
input:focus + .slider { box-shadow: 0 0 1px #f97316; }
input:checked + .slider:before { transform: translateX(26px); }
.slider.round { border-radius: 34px; }
.slider.round:before { border-radius: 50%; }

@media (max-width: 900px) {
  .sms-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .user-subscriptions-page {
    padding: 16px 12px;
  }
  .page-header h1 {
    font-size: 2.2rem;
  }
  .section-card {
    padding: 16px 12px;
    border-radius: 8px;
  }
  .btn-primary,
  .btn-outline,
  .tab-btn {
    width: 100%;
    text-align: center;
  }
}
</style>